export const requiredBillingAddressTypes = [
  'credit_card',
  'pix'
] as PaymentMethod[]
